// Page translators move nodes React rendered: https://github.com/facebook/react/issues/11538
export function guardTranslatedDom() {
    const { removeChild, insertBefore } = Node.prototype;

    Node.prototype.removeChild = function (child) {
        if (child.parentNode === this) {
            return removeChild.call(this, child);
        }

        console.warn('[DOM] removeChild on a node moved out of its parent', child);

        return child.parentNode ? removeChild.call(child.parentNode, child) : child;
    };

    Node.prototype.insertBefore = function (node, reference) {
        if (!reference || reference.parentNode === this) {
            return insertBefore.call(this, node, reference);
        }

        console.warn('[DOM] insertBefore with a reference node moved out of its parent', reference);

        let child = reference;
        while (child && child.parentNode !== this) {
            child = child.parentNode;
        }

        return insertBefore.call(this, node, child);
    };
}
